<template>
  <div class="water-mark">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'WaterMark',
  props: {
    text: {
      type: String,
      required: true
    },
    opacity: {
      type: Number,
      default: 15
    },
    fontSize: {
      type: Number,
      default: 12
    },
    disabled: Boolean
  },
  data () {
    return {
      waterMarkRect: {
        width: 300,
        height: 240
      },
      waterMarkEl: null,
      waterMarkObserver: null
    }
  },
  computed: {
    base64Image () {
      return this.createBase64(this.text)
    }
  },
  methods: {
    createBase64 (text) {
      const canvas = document.createElement('canvas')
      Object.assign(canvas, this.waterMarkRect)
      const context = canvas.getContext('2d')
      if (context) {
        context.rotate(-Math.PI / 6)
        context.font = `${this.fontSize}px Vedana`
        context.fillStyle = `rgba(0, 0, 0, ${this.opacity / 100})`
        context.textAlign = 'left'
        context.textBaseline = 'middle'
        context.fillText(text, this.waterMarkRect.width / 20, this.waterMarkRect.height)
      }
      return canvas.toDataURL('image/png')
    },
    createWaterMark () {
      const div = document.createElement('div')
      div.style.position = 'absolute'
      div.style.left = '0px'
      div.style.top = '0px'
      div.style.right = '0px'
      div.style.bottom = '0px'
      div.style.zIndex = '99999'
      div.style.pointerEvents = 'none'
      div.style.background = `url(${this.base64Image}) left top repeat`
      return div
    },
    setWaterMark () {
      if (this.waterMarkEl) {
        this.waterMarkEl.remove()
      }
      if (!this.disabled) {
        this.waterMarkEl = this.createWaterMark()
        this.$el.appendChild(this.waterMarkEl)
      }
    },
    bindObserver () {
      if (this.waterMarkObserver) {
        this.waterMarkObserver.observe(this.$el, {
          childList: true,
          subtree: true,
          attributes: true
        })
      }
    },
    unbindObserver () {
      if (this.waterMarkObserver) {
        this.waterMarkObserver.disconnect()
      }
    }
  },
  created () {
    this.waterMarkObserver = new MutationObserver(mutationRecords => {
      let waterMarkEl = this.waterMarkEl
      if (waterMarkEl) {
        let modified = mutationRecords.some(mutationRecord => {
          if (mutationRecord.target === waterMarkEl) {
            return true
          }
          let removedNodes = mutationRecord.removedNodes
          if (removedNodes && removedNodes.length) {
            for (let i = 0; i < removedNodes.length; i++) {
              if (removedNodes[i] === waterMarkEl) {
                return true
              }
            }
          }
        })
        if (modified) {
          this.setWaterMark()
        }
      }
    })
  },
  mounted () {
    this.setWaterMark()
    this.bindObserver()
  },
  beforeDestroy () {
    this.unbindObserver()
  },
  watch: {
    disabled () {
      this.setWaterMark()
    }
  }
}
</script>

<style lang="scss">
  .water-mark {
    position: relative;
  }
</style>
